import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../services/azure-api.service";
import { DtoCountry } from "./models/DtoCountry";
import {DtoEventAction} from "./models/DtoEventAction";
import {ActionType} from "./enums/actionType";
import {DtoBranchUser} from "./models/DtoBranchUser";
import {DtoEmployeeName} from "./models/DtoEmployeeName";

@Injectable()
export class SharedDataService {
    private apiUrlBaseItem: string;
    private apiUrlEventAction: string;
    private apiUrlUser: string;

    constructor(private http: AzureApiService) {
        this.apiUrlBaseItem = 'baseitem';
        this.apiUrlEventAction = 'eventaction';
        this.apiUrlUser = 'user'
    }

    public getCountries = (): Observable<DtoCountry[]> => {
        return this.http.get<DtoCountry[]>(`${this.apiUrlBaseItem}/countries`);
    };

    public getEventActions = (types: ActionType[]): Observable<DtoEventAction[]> => {
        return this.http.post<DtoEventAction[]>(`${this.apiUrlEventAction}/types`, types);
    };

    public getBranches = (): Observable<DtoBranchUser[]> => {
        return this.http.get<DtoBranchUser[]>(`${this.apiUrlUser}/branches`);
    };

    public getBranchesWithAll = (): Observable<DtoBranchUser[]> => {
        return this.http.get<DtoBranchUser[]>(`${this.apiUrlUser}/branches/withall`);
    };

    public getActiveEmployeesWithAll = (): Observable<DtoEmployeeName[]> => {
        return this.http.get<DtoEmployeeName[]>(`employee/activelist/withall`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/shared/shared-data.service.ts